import React from 'react';
import PropTypes from 'prop-types';
import {NoSsr, Paper, Popper, Typography} from '@mui/material';
import {generateVirtualElement, useMouseTracker} from "@mui/x-charts/ChartsTooltip/utils";
import {useAxisTooltip} from "@mui/x-charts";

function ThrowPackingTempLineChartTooltip(props: any) {
    const tooltipData = useAxisTooltip();
    const mousePosition = useMouseTracker(); // Track the mouse position on chart.

    if (!tooltipData || !mousePosition) {
        // No data to display
        return null;
    }

    // The pointer type can be used to have different behavior based on pointer type.
    const isMousePointer = mousePosition?.pointerType === 'mouse';
    // Adapt the tooltip offset to the size of the pointer.
    const yOffset = isMousePointer ? 0 : 40 - mousePosition.height;
    
    const seriesItemToDisplay = tooltipData.seriesItems.find((seriesItem) => seriesItem.seriesId === props.series.id);
    if (!seriesItemToDisplay) {
        return <div/>
    }

    return (
        <NoSsr>
            <Popper
                sx={{
                    pointerEvents: 'none',
                    zIndex: (theme) => theme.zIndex.modal,
                }}
                open
                placement={isMousePointer ? 'top-end' : 'top'}
                anchorEl={generateVirtualElement(mousePosition)}
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [0, yOffset],
                        },
                    },
                ]}
            >
                <Paper
                    elevation={0}
                    sx={{
                        m: 1,
                        border: 'solid',
                        borderWidth: 2,
                        borderColor: 'divider',
                        table: { borderSpacing: 0 },
                        thead: {
                            td: {
                                px: 1.5,
                                py: 0.75,
                            },
                                borderBottom: 'solid',
                                borderWidth: 2,
                                borderColor: 'divider',
                        },
                        tbody: {
                            'tr:first-child': { td: { paddingTop: 1.5 } },
                            'tr:last-child': { td: { paddingBottom: 1.5 } },
                            tr: {
                                'td:first-child': { paddingLeft: 1.5 },
                                'td:last-child': { paddingRight: 1.5 },
                                td: {
                                    paddingRight: '7px',
                                    paddingBottom: '10px',
                                },
                            },
                        },
                    }}
                >
                    <table>
                        <thead>
                            <tr>
                                <td colSpan={3}>
                                    <Typography>{tooltipData.axisFormattedValue}</Typography>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >
                                    <Typography color={seriesItemToDisplay.color}>{seriesItemToDisplay.seriesId}</Typography>
                                </td>
                            </tr>
                            <tr key={seriesItemToDisplay.seriesId}>
                                <td>
                                    <Typography fontWeight={'light'}>
                                        Temperature: <Typography component="span" fontWeight="bold">{seriesItemToDisplay.formattedValue}</Typography>
                                    </Typography>                            </td>
                            </tr>
                        </tbody>
                    </table>
                </Paper>
            </Popper>
        </NoSsr>
    );
}

export default ThrowPackingTempLineChartTooltip;